import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/constants/testIds";

const WORDS = [
  { text: "STRATEGY", stroke: "#EA580C" },
  { text: "TECHNOLOGY", stroke: "#4F46E5" },
  { text: "PRODUCT", stroke: "#0D9488" },
  { text: "INTELLIGENCE", stroke: "#DB2777" },
  { text: "EXECUTION", stroke: "#EA580C" },
  { text: "PULSE AGENTIC", stroke: "#111111" },
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid={MARQUEE.section}
      className="relative py-10 md:py-14 border-y border-border/70 bg-muted/40 overflow-hidden"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span
            key={i}
            className="font-display text-transparent text-4xl md:text-6xl tracking-tighter mx-8 md:mx-12 select-none"
            style={{ WebkitTextStroke: `1px ${w.stroke}` }}
          >
            {w.text}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
